<template>
    <span>
        <span v-if="row.meetStatus === 2" v-pageBtn-lbl="'look'" style="color: #409efe" @click="toDetail">查看</span>
        <template v-else>
            <QRcode v-if="row.meetPersonType === 4" :row="row" :index="index" :column="column" />
            <DHzoperation v-else :row="row" :index="index" :column="column" />
        </template>
    </span>
</template>

<script>
import DHzoperation from './dhzoperation.vue'
import QRcode from './QRcode.vue'

export default {
    components: {
        DHzoperation,
        QRcode
    },
    props: {
        row: {
            type: Object,
            default: function () {
                return {}
            }
        },
        index: { type: Number, default: 0 },
        column: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    methods: {
        toDetail() {
            this.$vnode.context.$vnode.context.onCellClick(this.row)
        }
    }
}
</script>

<style>
</style>
